<div class="emd-container boder-none">
    <div class="title">
        <h2 class="emd-text _align_center _size_page _type_bold">{{ title() }}</h2>
    </div>
    <div class="emd-container__content" style="padding: 0rem 2rem">
        <ng-content></ng-content>
    </div>

    <div class="emd-container__footer eu-justify_end" style="padding: 1rem 2rem">
        <ng-content select="footer-actions" #footerActions></ng-content>
    </div>
</div>
